import React, { useState } from 'react';
import styled from 'styled-components';

import { AlertActionElem } from '../../common/alert-action';
import { GridElem } from '../../common/grid';
import { DATA_INTER } from './constant';
import { USER_ITEM_DATA_INTER } from '../../data/user/constant';
import { Spacing } from '../../theme';
import { COLOR_ENUM } from '../../theme/color';
import { CardUser } from './frame/card-user';
import { SkeletonDataElem } from '../../common/skeleton-data';
import { UserFilterContainer } from '../user-filter';
import { EmptyListElem } from '../../common/empty-list-elem';
import { TextElem } from '../../common/text';
import { PaginationElem } from '../../common/pagination';

export const Component: React.FC<{
  list?: DATA_INTER;
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
  search: string;
  setSearch: Function;
  count?: number;
  onChangePage: (arg: number) => void;
  page: number;
  pageSize: number;
  pageCount: number;
}> = ({
  list,
  isLoading,
  isSuccess,
  isError,
  errorMessage,
  search,
  setSearch,
  count,
  page,
  onChangePage,
  pageSize,
  pageCount,
}) => {
  const isCount = count !== 0 && typeof count !== 'undefined';

  const [openCardId, setOpenCardId] = useState<string | null>(null);

  const handleCardClick = (id: string) => {
    setOpenCardId((prevOpenCardId) => (prevOpenCardId === id ? null : id));
  };

  return (
    <GridElemStyled spacing={6}>
      <UserFilterContainer search={search} setSearch={setSearch} />
      {isLoading && <SkeletonDataStyled />}
      {isError && <AlertActionElem tid={`ERROR.${errorMessage}`} />}
      <GridStyled>
        {isCount && (
          <CountStyled
            color="textSecondary"
            size="small"
            type="medium"
            tid="USER.LIST.COUNT"
            tvalue={{ count }}
          />
        )}
        {list?.isEmpty && !isLoading && (
          <EmptyListElem
            titleTid="USER.LIST.IS_EMPTY_TITLE"
            descriptionTid="USER.LIST.IS_EMPTY_DESCRIPTION"
          />
        )}
        {isSuccess &&
          list &&
          !list.isEmpty &&
          list?.list.map((item: USER_ITEM_DATA_INTER) => (
            <>
              <Divider />
              <CardUser
                isOpen={openCardId === item.id}
                onClick={() => handleCardClick(item.id)}
                data={item}
              />
            </>
          ))}
        {!list?.isEmpty && <Divider />}
      </GridStyled>
      {!list?.isEmpty && (
        <PaginationStyled
          defaultPageSize={pageSize}
          current={page}
          onChange={onChangePage}
          total={pageCount}
        />
      )}
    </GridElemStyled>
  );
};

const PaginationStyled = styled(PaginationElem)`
  position: absolute;
  bottom: ${Spacing(33)};
  left: 50%;
  transform: translateX(-50%);
`;

const CountStyled = styled(TextElem)`
  margin-bottom: ${Spacing(3)};
`;

const SkeletonDataStyled = styled(SkeletonDataElem)`
  margin-top: ${Spacing(6)};
`;

const GridElemStyled = styled(GridElem)`
  margin-top: ${Spacing(1)};
  margin-bottom: ${Spacing(22)};
`;

const Divider = styled.div`
  background-color: ${({ theme }) => theme[COLOR_ENUM.DIVIDER]};
  height: 1px;
  width: 100%;
`;

const GridStyled = styled(GridElem)`
  grid-auto-columns: auto max-content max-content;
  row-gap: ${Spacing(1)};
`;
